import { AlertsButton } from '../common/AlertsButton';

interface Props {
    isAlertOn: boolean;
    label?: string;
    onClick: () => void;
}

export const BanksAlertsButton = ({ isAlertOn, label, onClick }: Props) => {
    return <AlertsButton isSelected={isAlertOn} onClick={onClick} label={label} />;
};
